export default __webpack_public_path__ + "static/media/edit_icon.9a2e8da0.svg";